import { render, staticRenderFns } from "./CardTarjaTVZComments.vue?vue&type=template&id=b7eee40c&scoped=true"
import script from "./CardTarjaTVZComments.vue?vue&type=script&lang=js"
export * from "./CardTarjaTVZComments.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaTVZComments.vue?vue&type=style&index=0&id=b7eee40c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7eee40c",
  null
  
)

export default component.exports